export default "__VITE_ASSET__DfyuOOEY__"